export default "__VITE_ASSET__7bd9e662__"